import type { ReactNode } from 'react';
import { Panel } from '@sorrem-client/ui/components';
import styles from './LoginPage.module.scss';

interface AccessScreenProps {
    /** Names the panel for screen readers. */
    readonly ariaLabel: string;
    /** The small line above the title. */
    readonly kicker: string;
    readonly title: string;
    readonly subtitle: ReactNode;
    /** The actions, in the framed form panel. */
    readonly children: ReactNode;
    /** Anything below the form (a prompt, a footnote). */
    readonly after?: ReactNode;
}

/**
 * The screen a player meets at the door: the painted background, a title,
 * and what they can do next. Sign-in and the access-denied screens share it.
 */
export function AccessScreen({ ariaLabel, kicker, title, subtitle, children, after }: AccessScreenProps): JSX.Element {
    return (
        <div className={styles.screen}>
            <div className={styles.backgroundArt} />
            <div className={styles.backgroundShade} />

            <section className={styles.panel} aria-label={ariaLabel}>
                <header className={styles.header}>
                    <p className={styles.kicker}>{kicker}</p>
                    <h1 className={styles.title}>{title}</h1>
                    <p className={styles.subtitle}>{subtitle}</p>
                </header>

                <Panel className={styles.formPanel} frame="thick">
                    <div className={styles.form}>{children}</div>
                </Panel>

                {after}
            </section>
        </div>
    );
}
